import { Card } from '@/components/ui/card';
import { cn } from '@/lib/utils';
import { t } from '@/i18n';
import { FIELDS, REQUIRED } from '@/lib/planImport';

// One select per field: which column of the pasted table holds it.
export const ImportMapping = ({ headers, mapping, onChange }) => (
  <Card className="p-4 space-y-3">
    <div>
      <div className="text-sm font-semibold">{t('import.mapping.title')}</div>
      <div className="text-xs text-muted-foreground">{t('import.mapping.hint')}</div>
    </div>
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
      {FIELDS.map(f => (
        <label key={f} className="text-xs space-y-1">
          <span className={cn('font-medium', REQUIRED.includes(f) && "after:content-['*'] after:text-red-600")}>{t(`import.field.${f}`)}</span>
          <select
            aria-label={t(`import.field.${f}`)}
            value={mapping[f] ?? ''}
            onChange={e => onChange({ ...mapping, [f]: e.target.value === '' ? undefined : Number(e.target.value) })}
            className="w-full rounded-md border bg-background px-2 py-1.5 text-sm"
          >
            <option value="">{t('import.mapping.none')}</option>
            {headers.map((h, i) => <option key={i} value={i}>{h}</option>)}
          </select>
        </label>
      ))}
    </div>
  </Card>
);
